import { useQuery } from "react-query";
import { JoiningPage } from "translations/src/models/joining-pages";
import { TranslationType } from "translations/src/services/joiningPages";

import { QueryKeys } from "../constants/QueryKeys";
import { joiningPageTranslationsService } from "../services";

/**
 * Used to fetch page translations from Umbraco
 * Pass page key to get translation for page
 */
export const useFetchPageTranslation = <T extends JoiningPage>(
  page: T,
  locale: string
): {
  data: TranslationType<T> | undefined;
  error: unknown;
  isLoading: boolean;
  isError: boolean;
} => {
  const { data, error, isLoading, isError } = useQuery(
    [QueryKeys.FETCH_TRANSLATIONS, locale, page],
    () =>
      joiningPageTranslationsService.getFormPageTranslations({ locale, page }),
    {
      cacheTime: Infinity,
      staleTime: Infinity,
    }
  );

  return { data, error, isLoading, isError };
};
